export default "__VITE_ASSET__Cwc1Dps___"